export interface FaqItem {
  id: string;
  group: string;
  question: string;
  answer: string;
}

export const faqGroups = [
  "使用与收藏",
  "内容与更新",
  "账号与隐私",
];

export const faqs: FaqItem[] = [
  {
    id: "f01",
    group: "使用与收藏",
    question: "5看料网的收藏、书签和标记有什么区别？",
    answer:
      "收藏用于把整条话题存进「我的收藏」，方便之后整体回看；书签更强调给内容加一个便于检索的定位；标记则是给话题打上你自己的状态，比如「已看完」「待追」。三者可以同时使用，互不影响。",
  },
  {
    id: "f02",
    group: "使用与收藏",
    question: "保存过的话题会一直保留吗？",
    answer:
      "当前版本的收藏、书签与标记会保存在你使用的这台设备上。只要不清除浏览器数据，重新打开网站仍然可以看到之前保存的内容。",
  },
  {
    id: "f03",
    group: "使用与收藏",
    question: "如何对感兴趣的内容持续关注？",
    answer:
      "在话题卡片或详情区域点击关注按钮，就可以把该话题加入持续追踪列表。当同一话题出现新的动态时，你可以在关注列表中优先看到它。",
  },
  {
    id: "f04",
    group: "使用与收藏",
    question: "收藏的内容可以导出或整理吗？",
    answer:
      "可以在「话题库」页面按分类查看收藏内容，并配合搜索快速定位。后续我们会评估导出为清单的能力，让整理更省事。",
  },
  {
    id: "f05",
    group: "内容与更新",
    question: "话题大致多久更新一次？",
    answer:
      "编辑部在工作日会保持较为密集的更新，热点出现时会随时补充。节假日会适度放慢节奏，但重要的娱乐动态仍会及时收录。",
  },
  {
    id: "f06",
    group: "内容与更新",
    question: "如果发现某条内容信息有误怎么办？",
    answer:
      "欢迎通过「关于我们」页面的反馈入口告诉我们。我们会在核实后尽快修改或下架，并在页面标注更新说明，尽量保持内容可靠。",
  },
  {
    id: "f07",
    group: "内容与更新",
    question: "话题的「热度」是怎么计算的？",
    answer:
      "热度是综合阅读、收藏、转发与讨论量得出的参考值，用于展示话题在近期的受关注程度，并不代表对内容本身的评价。",
  },
  {
    id: "f08",
    group: "账号与隐私",
    question: "使用收藏功能需要注册账号吗？",
    answer:
      "目前不需要。收藏、书签与标记都保存在本地设备上，不强制登录即可使用。若未来开放云端同步，我们会提前说明并让你自行选择是否登录。",
  },
  {
    id: "f09",
    group: "账号与隐私",
    question: "你们会收集我的浏览记录吗？",
    answer:
      "当前版本的收藏与浏览状态均保存在本地，我们不会将这些数据与个人身份关联。页面访问的基础统计仅用于了解整体内容表现。",
  },
];